export enum Role {
  Patient = "ROLE_PATIENT",
  Doctor = "ROLE_DOCTOR",
  CareGiver = "ROLE_CAREGIVER",
  Admin = "ROLE_ADMIN",
  Developer = "ROLE_DEVELOPER",
}
